import { AxiosInstance } from "../../../axios/axiosInstance";
import { apiRoutes } from "../../../utils/ApiRoutes";

export const AdminHelperApi = async () => {
    const response = await AxiosInstance.post(
        apiRoutes.adminDashboard,
    )
    return response
}



export const UpdatePlanApi = async (payload: any) => {
    const response = await AxiosInstance.post(
        apiRoutes?.updateAddonPlan,
        payload
    )
    return response
}


export const AddScansApi = async (payload: any) => {
    const response = await AxiosInstance.post(
        apiRoutes?.addscans,
        payload
    )
    return response
}
export const AddCreditApi = async (payload: any) => {
    const response = await AxiosInstance.post(
        apiRoutes?.addcredit,
        payload
    )
    return response
}

export const addAiCreditApi = async (business_id: string, credits: number) => {
    const response = await AxiosInstance.post(
        apiRoutes?.addAiCredit,
        {
            business_id,
            credits
        }
    )
    return response
}

export const EnableCheckinProApi = async (payload: any) => {
    const response = await AxiosInstance.post(
        apiRoutes?.enablechekinpro,
        payload
    )
    return response
}